import script from "./EmptyState.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyState.vue?vue&type=script&setup=true&lang=js"

import "./EmptyState.vue?vue&type=style&index=0&id=4adba236&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4adba236"]])

export default __exports__